import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const ReceiptsAndInvoicesRaw = React.lazy(() => import(/* webpackChunkName: "ReceiptsAndInvoices" */ './ReceiptsAndInvoices'));
export const ReceiptsAndInvoices = () => (React.createElement(Page, { title: "View client payments", description: "View client payments" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(ReceiptsAndInvoicesRaw, null)))));
